import { render, staticRenderFns } from "./chemical-engineering-2.vue?vue&type=template&id=0ff6ebb6&"
import script from "./chemical-engineering-2.vue?vue&type=script&lang=js&"
export * from "./chemical-engineering-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports